import type { Heidi2BookDemoPhoneInputProps } from '@heidi/agents';
import { PhoneInput } from '@heidi/snowflake-ui/phone-input';
import { countries } from '@heidi/utils/countries';
import { type Country } from 'react-phone-number-input';

const HEIDI_2_BOOK_DEMO_PHONE_COUNTRIES = countries
  .map((country) => country.countryCode)
  .filter((code): code is string => Boolean(code)) as Country[];

/**
 * The app phone input, shaped to the port the Heidi II book-a-demo form asks
 * for — the package cannot import the app primitive itself.
 */
export const Heidi2BookDemoPhoneInput = (props: Heidi2BookDemoPhoneInputProps) => (
  <PhoneInput
    id={props.id}
    name={props.name}
    value={props.value}
    onChange={(value) => props.onChange?.(value ?? '')}
    onBlur={props.onBlur}
    placeholder={props.placeholder}
    autoComplete={props.autoComplete}
    disabled={props.disabled}
    defaultCountry={props.defaultCountry as Country | undefined}
    allowedCountries={HEIDI_2_BOOK_DEMO_PHONE_COUNTRIES}
    countrySelectPopoverClassName="z-[102]"
  />
);
